
interface HeroProps {
  onCTAClick: () => void;
}

export default function Hero({ onCTAClick }: HeroProps) {
  return (
    <section className="relative py-12 sm:py-20 md:py-28 flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-[#0a1628] via-[#0d1b2e] to-[#1a2744]"></div>
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center w-full">
        <h1 className="text-xl sm:text-3xl md:text-4xl font-bold text-white mb-3 leading-snug">
          戦略・DX案件に参画する<br />
          フリーランスコンサルタントのための<br />
          プロジェクトプラットフォーム
        </h1>
        <p className="text-base sm:text-xl md:text-2xl text-amber-400 font-semibold mb-5">
          単価160万円〜210万円クラスの<br />
          戦略・DX案件のご紹介
        </p>
        <button
          onClick={onCTAClick}
          className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold text-sm sm:text-lg px-8 sm:px-12 py-3 sm:py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
        >
          今すぐ無料登録
        </button>
      </div>
    </section>
  );
}
